const sensors = window.sensorsDataAnalytic201505
const is_production = process.env.NODE_ENV === 'production'
console.log(is_production, '###############')
const options = {
  // server_url: is_production?'https://datasink.thebeastshop.com/sa?project=production':'https://datasink.thebeastshop.com/sa?project=default',
  // server_url: 'https://datasink.thebeastshop.com/sa?project=default',
  server_url: 'https://datasink.thebeastshop.com/sa?project=production',
  platform_type: 'WAP'
}
class Sa {
  constructor ({
    server_url = '',
    platform_type = ''
  }) {
    this.isSDKinit = false
    this.server_url = server_url

    // 公共属性
    this.is_login = false
    this.vip_level = ''
    this.current_page_type = ''
    this.current_page_name = ''
    this.current_page_id = ''
    this.platform_type = platform_type
    this.thelatest_utm_source = ''

    // 前向页面名称
    this.refer_page_name = ''
    this.refer_page_type = ''
    this.refer_page_id = ''
  }

  setParams () {
    if (this.isSDKinit) return

    this._setParam()
    this._registerApp()
  }

  changeIdentify (distinctID) {
    sensors.identify(distinctID, true)
  }

  track () {
    return sensors.track(...arguments)
  }

  addCart (options) {
    const params = {
      ...this.getReferPageName(),
      ...options
    }

    this.track('AddToShoppingCart', params)
  }

  registerButtonClick(name) {
    this.track('RegisterButtonClick', {
      button_name: name
    })
  }

  getUTMProp () {
    const {
      $latest_utm_campaign,
      $latest_utm_content,
      $latest_utm_source,
      $latest_utm_term
    } = sensors.getPresetProperties()

    return {
      theLatestUtmCampaign: $latest_utm_campaign,
      theLatestUtmContent: $latest_utm_content,
      theLatestUtmSource: $latest_utm_source,
      theLatestUtmTerm: $latest_utm_term
    }
  }
  
  sharePage (type, options) {
    const params = {
      ...this.getReferPageName()
    }

    this.track('ShareClick', {
      share_type: type,
      ...params,
      ...options
    })
  }

  shareSave () {
    const params = {
      ...this.getReferPageName()
    }

    this.track('MPShareSave', {
      ...params
    })
  }

  editCart (type) {
    this.track('EditShoppingCart', {
      shopping_cart_edit_type: type
    })
  }

  buyNow (options) {
    const params = {
      ...this.getReferPageName(),
      ...options
    }

    this.track('buyNow', options)
  }

  addIndex (index, num) {
    return index + num
  }

  setOpenid (openId) {
    return sensors.setOpenid(openId)
  }

  login (id) {
    this.is_login = true

    return sensors.login(id)
  }

  setCurrentPageWithOutRefer (type, name, id, options) {
       // this.refer_page_name = this.current_page_name
    // this.refer_page_type = this.current_page_type
    // this.refer_page_id = this.current_page_id

    this.current_page_type = type || ''
    this.current_page_name = name || ''
    this.current_page_id = id || ''

    this.setReferPageNameByCache({
      current_page_name: name || '',
      current_page_id: id || '',
      current_page_type: type || ''
    })

    return { ...options }
  } 

  // 设置每个页面的公共属性
  setCurrentPage (type, name, id, options) {
    // this.refer_page_name = this.current_page_name
    // this.refer_page_type = this.current_page_type
    // this.refer_page_id = this.current_page_id
    const referData = this.getReferPageNameByCache()

    if (referData) {
      this.refer_page_name = referData.current_page_name
      this.refer_page_type = referData.current_page_type
      this.refer_page_id = referData.current_page_id
    }

    this.current_page_type = type || ''
    this.current_page_name = name || ''
    this.current_page_id = id || ''

    this.setReferPageNameByCache({
      current_page_name: name || '',
      current_page_id: id || '',
      current_page_type: type || ''
    })

    return { ...options }
  }

  // 获取前向页面名称
  getReferPageName () {
    return {
      refer_page_name: this.refer_page_name,
      refer_page_id: this.refer_page_id,
      refer_page_type: this.refer_page_type
    }
  }

  getReferPageNameByCache () {
    return JSON.parse(window.sessionStorage.getItem('_sa_refer')) || null
  }

  setReferPageNameByCache (data) {
    window.sessionStorage.setItem('_sa_refer', JSON.stringify(data))
  }

  getActivity (labels) {
    const activity = []
    labels.forEach(label => {
      activity.push(label.type)
    })

    return activity
  }

  getProp () {
    return sensors.getPresetProperties()
  }

  getAnonymousID () {
    return sensors.quick('getAnonymousID')
  }

  clickNavBar (name) {
    return this.track('NavigationBar', {
      button_name: name
    })
  }

  clickPerson (name) {
    return this.track('PersonalCenter', {
      button_name: name
    })
  }

  _autoQuick () {
    return sensors.quick('autoTrack')
  }

  init () {
    this._registerPage()
    // this._autoQuick()

    sensors.init({
      server_url: this.server_url,
      heatmap: {
        // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        // 默认只有点击 a input button textarea 四种元素时，才会触发 $WebClick 元素点击事件
        clickmap: 'default'
      },
      show_log: true,
      use_client_time: true,
      app_js_bridge: true,
      send_type: 'beacon'
    })
  }

  _registerPage () {
    sensors.registerPage({
      platform_type: this.platform_type,

      is_login: () => {
        return this.is_login
      },

      vip_level: () => {
        return this.vip_level
      },

      current_page_type: () => {
        return this.current_page_type
      },

      current_page_name: () => {
        return this.current_page_name
      },

      current_page_id: () => {
        return this.current_page_id
      },

      thelatest_utm_source: () => {
        return this.thelatest_utm_source
      }
    })
  }
}

module.exports = new Sa(options)

function loop () {}



// WEBPACK FOOTER //
// ./static/lib/sa.js